import React from 'react';
import Container from './container'
import Text from './text'
import Image from './image'
import Iframe from './iframe'

class NewCol extends React.Component {

  render() {
    return (
      <div class="">
        <button class="btn btn-primary" onClick={e => this.props.parent.changeContentType(e,'text')}>Text</button>
        <button class="btn btn-primary ml-2" onClick={e => this.props.parent.changeContentType(e,'image')}>Image</button>
        {this.props.iframes && <button class="btn btn-primary ml-2" onClick={e => this.props.parent.changeContentType(e,'iframe')}>Iframe</button>}
        <button class="btn btn-primary ml-2" onClick={e => this.props.parent.changeContentType(e,'container')}>Container</button>
      </div>
    )
  }

}

class Resize extends React.Component {

  pos = {
    start: {
      x: null,
      y: null
    },
    move: {
      x: null,
      y: null,
      dx: null,
      dy: null,
      tx: null,
      ty: null
    },
    end: {
      x: null,
      y: null,
      dx: null,
      dy: null,
      tx: null,
      ty: null      
    }
  }
  time = 0

  start = (e) => {
    e.stopPropagation()
    e.preventDefault()
    this.time = Date.now()
    this.props.root.onMouseMove = this.move
    this.props.root.onMouseUp = this.end

    this.pos.move.x = this.pos.start.x = e.screenX
    this.pos.move.y = this.pos.start.y = e.screenY
    this.props.onMove({
      type: "start",
      pos: this.pos
    })    
  }

  move = (e) => {
    if (e.screenX == 0 && e.screenY == 0) return;
    // this.time.now = Date.now()
    this.pos.move.dx = e.screenX-this.pos.move.x
    this.pos.move.dy = e.screenY-this.pos.move.y
    this.pos.move.x = e.screenX
    this.pos.move.y = e.screenY
    this.pos.move.tx = this.pos.move.x-this.pos.start.x
    this.pos.move.ty = this.pos.move.y-this.pos.start.y  
    this.props.onMove({
      type: "move",
      pos: this.pos
    })    
  }

  end = (e) => {
    this.props.root.onMouseMove = null
    this.props.root.onMouseUp = null
    this.pos.end.dx = e.screenX-this.pos.move.x
    this.pos.end.dy = e.screenY-this.pos.move.y
    this.pos.end.x = e.screenX
    this.pos.end.y = e.screenY
    this.pos.end.tx = this.pos.move.x-this.pos.start.x
    this.pos.end.ty = this.pos.move.y-this.pos.start.y
    // console.log("time",Date.now()-this.time)
    if (Date.now()-this.time < 100) {
      this.props.onMove({
        type: "reset"
      })
    } else {
      this.props.onMove({
        type: "end",
        pos: this.pos
      })
    }    
  }

  render() {
    return (
      <div 
        class={"editor-resize "+this.props.type}
        onMouseDown={this.start}
      />
    )
  }

}

export default class Col extends React.Component {

  domEl = null

  state = {
    'width': null,
    'height': null,
  }
  width = null
  height = null

  changeContentType = (e,type) => {
    this.props.el.content.type = type
    this.props.el.content.content = type == "container" ? {type: "container"} : "";
    this.setState({el: this.props.el})
  }

  onResizeRight = (e) => {  
    switch (e.type) {
      case "start":
        this.width = this.domEl.offsetWidth
        this.setState({width: this.width})      
        break;
      case "move":
        if (e.pos.move.dx != 0) {
          this.width += e.pos.move.dx;
          this.setState({width: this.width})      
        }      
        break;
      case "end":
        this.width += e.pos.end.dx;
        this.setState({width: this.width}, () => {
          this.props.el.width = this.width
          this.props.root.update()
        })         
        break;
      case "reset":
        this.width = null
        this.setState({width: null})
        this.props.el.width = this.width
        this.props.root.update()        
        break;                        
    }  
  }

  onResizeBottom = (e) => {
    switch (e.type) {
      case "start":
        this.height = this.domEl.clientHeight
        this.setState({height: this.height})
        break;
      case "move":
        if (e.pos.move.dy != 0) {
          this.height += e.pos.move.dy;
          this.setState({height: this.height})      
        }
        break;
      case "end":      
        this.height += e.pos.end.dy
        this.setState({height: this.height}, () => {
          this.props.el.height = this.height
          this.props.root.update()        
        })   
        break;
      case "reset":
        this.height = null
        this.setState({height: null})
        this.props.el.height = this.height
        this.props.root.update()      
        break;      
    }
  }  

  render() {
    let editMode = this.props.mode == "edit"
    let content = this.props.el.content || {
      type: editMode ? "new" : "text",
      content: ""
    };
    if (content.type == "new" && !editMode) content.type = "text"
    var Component;
    switch (content.type) {
      case "container":
        Component = Container
        content.content = typeof content.content == "object" ? content.content : []
        break;
      case "image":
        Component = Image
        content.content = typeof content.content == "string" ? content.content : ""      
        break;
      case "iframe":
        Component = Iframe
        content.content = typeof content.content == "string" ? content.content : ""      
        break;
      case 'new':
        Component = NewCol        
        break;
      default:      
        Component = Text
        content.content = typeof content.content == "string" ? content.content : ""                
        content.type = "text"
        break;
    }
    this.props.el.content = content
    
    let selected = editMode && this.props.root.state.selected == this
    let width = editMode ? this.state.width || this.props.el.width : this.props.el.width
    let height = editMode ? this.state.height || this.props.el.height : this.props.el.height
    var style = undefined;
    if (width || height) {
      style = {}
      if (width) style.flex = "0 0 "+width+"px";
      if (height) style.height = height
    }
    return (
      <div 
        class={"col col-sm news-col news-grid mode-"+this.props.mode+(selected ? " selected" : "")} 
        onClick={editMode ? e => this.props.onSelect(e,this.props.el,this) : undefined}
        ref={ref => this.domEl = ref}
        style={style}
      >
        <Component 
          content={content.content}
          el={content}
          parent={this}
          mode={this.props.mode}
          root={this.props.root}
          onSelect={this.props.onSelect}
          iframes={this.props.iframes}
        /> 
        {editMode && <Resize type="right" onMove={this.onResizeRight} root={this.props.root} parent={this} />}          
        {editMode && <Resize type="bottom" onMove={this.onResizeBottom} root={this.props.root} parent={this} />}
        
      </div>        
    ) 
  }

}